import api from '@/shared/api';
import config from '@/config';
import SignalRService from '@/shared/services/SignalRService';
const registrationUrl = `${config.appUrls.api}/api/registration`;
const invoiceRegistrationUrl = `${config.appUrls.api}/api/InvoiceRegistration`;
/**
 * Maps `ScrollableTable` search params to the query keys the legacy `cx-table` sent
 * (`take`/`sort`). `search`/`filter` are JSON-encoded because that's how AngularJS'
 * `$httpParamSerializer` sent object params, and the API parses them back from JSON — the
 * shared axios serializer would otherwise emit bracket-style keys the API ignores.
 */
const toServerTableParams = (params) => ({
    take: params.pageSize,
    page: params.page,
    sort: params.sortKey,
    desc: params.desc,
    search: JSON.stringify(params.search || {}),
    filter: JSON.stringify(params.filter || {}),
});
export const retrieveRegistrations = (tableParams, filters, cancelToken) => api.base
    .get(registrationUrl, {
    params: Object.assign(Object.assign({}, toServerTableParams(tableParams)), filters),
    cancelToken,
})
    .then(({ data }) => data.registrations || []);
export const retrieveKpis = (tableParams, filters, cancelToken) => api.base
    .get(`${registrationUrl}/kpi`, {
    params: Object.assign(Object.assign({}, toServerTableParams(tableParams)), filters),
    cancelToken,
})
    .then(({ data }) => data);
export const createReport = (tableParams, filters, languageCode) => api.base.get(`${registrationUrl}/Report`, {
    params: Object.assign(Object.assign(Object.assign({}, toServerTableParams(tableParams)), filters), { languageCode, connectionId: SignalRService.getConnectionId() }),
});
/* ---------------------------------------------------------------- Per-row actions */
export const toggleBillable = (id, billable) => api.base
    .put(`${registrationUrl}/Billable/${id}`, null, { params: { billable } })
    .then(({ data }) => data);
export const toggleInForfait = (id, inForfait) => api.base
    .put(`${registrationUrl}/InForfait/${id}`, null, { params: { inForfait } })
    .then(({ data }) => data);
export const toggleNeverInvoice = (id, neverInvoice) => api.base
    .put(`${registrationUrl}/NeverInvoice/${id}`, null, { params: { neverInvoice } })
    .then(({ data }) => data);
export const toggleLock = (id, lock) => api.base
    .put(`${config.appUrls.api}/api/Registration/IsLocked/${id}`, null, { params: { lock } })
    .then(({ data }) => data);
export const deleteRegistration = (id) => api.base.delete(`${registrationUrl}/Delete/${id}`, { params: { deleteGroup: false } });
export const addRegistrationToDraft = (id) => api.base.post(`${invoiceRegistrationUrl}/BillRegistration/${id}`).then(({ data }) => data);
export const removeRegistrationFromDraft = (invoiceId, id, neverInvoice) => api.base
    .delete(`${invoiceRegistrationUrl}/Delete/${invoiceId}/${id}`, { params: { neverInvoice } })
    .then(({ data }) => data);
/* ------------------------------------------------------------------ Batch actions */
const batchUrl = `${config.appUrls.api}/api/Registration`;
const batchParamsFor = (tableParams, filters, extra) => (Object.assign(Object.assign(Object.assign({}, filters), toServerTableParams(tableParams)), extra));
export const batchDelete = (selection, tableParams, filters) => api.base
    .post(`${batchUrl}/BatchDelete`, selection, { params: batchParamsFor(tableParams, filters) })
    .then(({ data }) => data);
export const batchToggleLock = (selection, tableParams, filters, lock) => api.base
    .post(`${batchUrl}/BatchToggleLock`, selection, {
    params: batchParamsFor(tableParams, filters, { lock }),
})
    .then(({ data }) => data);
export const batchBill = (selection, tableParams, filters) => api.base
    .post(`${batchUrl}/BatchBill`, selection, { params: batchParamsFor(tableParams, filters) })
    .then(({ data }) => data);
export const batchUnbill = (selection, tableParams, filters, neverInvoice) => api.base
    .post(`${batchUrl}/BatchUnbill`, selection, {
    params: batchParamsFor(tableParams, filters, { neverInvoice }),
})
    .then(({ data }) => data);
/** Bulk-updates a single field on the selected/filtered registrations. Returns the count. */
export const batchUpdateField = (selection, model, tableParams, filters) => api.base
    .post(`${registrationUrl}/BatchUpdateField`, Object.assign(Object.assign({}, selection), model), {
    params: batchParamsFor(tableParams, filters),
})
    .then(({ data }) => data || 0);
